var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.601c-4.963 0-9-4.037-9-9 0-4.962 4.037-9 9-9s9 4.038 9 9c0 4.963-4.037 9-9 9zm0-16.875c-4.342 0-7.875 3.533-7.875 7.875 0 4.342 3.533 7.875 7.875 7.875 4.342 0 7.875-3.533 7.875-7.875 0-4.342-3.533-7.875-7.875-7.875zM8.71 12.811l5.625-5.625a.562.562 0 1 0-.795-.795l-5.227 5.227L6.46 9.766a.562.562 0 1 0-.795.795l2.25 2.25a.56.56 0 0 0 .795 0z",
    fill: "#F6B119",
    fillRule: "nonzero",
    stroke: "#F6B119",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.e842be0af2607ba8b9192af04e20b25d.svg";
export { ForwardRef as ReactComponent };